<template>
  <div class="why-choose-us">
    <!-- Section Header -->
    <div class="section-header">
      <h2 class="main-title">Why Trade with Socrates Legacy</h2>
    </div>

    <!-- Features Grid -->
    <div class="features-grid">
      <div class="grid-container">
        <div v-for="feature in features" :key="feature.id" class="feature-card">
          <div class="icon-container">
            <svg class="feature-icon" :viewBox="feature.viewBox" xmlns="http://www.w3.org/2000/svg">
              <path :d="feature.pathData"></path>
            </svg>
          </div>
          <div class="content-container">
            <h3 class="feature-title">{{ feature.title }}</h3>
            <h4 class="feature-subtitle">{{ feature.subtitle }}</h4>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyChooseUs',
  data() {
    return {
      features: [
        {
          id: 1,
          title: 'Trade Range',
          subtitle: 'Opportunities with Our Wide Range of Tradeable Assets',
          description: 'Embark on a dynamic trading journey with our platform\'s extensive offering of tradeable assets. Dive into diverse opportunities as you trade over a myriad of CFD instruments including Forex, Metals, Oils, and Indices.',
          viewBox: '0 0 496 512',
          pathData: 'M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z'
        },
        // {
        //   id: 2,
        //   title: 'PAMM Account',
        //   subtitle: 'Account Managing by Professional',
        //   description: 'Through a PAMM account, investors can benefit from the expertise of a skilled manager, fostering collaboration for potentially enhanced returns and diversified investment strategies.',
        //   viewBox: '0 0 640 512',
        //   pathData: 'M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z'
        // },
        {
          id: 3,
          title: 'Market Access',
          subtitle: 'Straight Through Processing (STP)',
          description: 'Trade directly with the interbank market without any intervention or dealing desk and price manipulation.',
          viewBox: '0 0 640 512',
          pathData: 'M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 1zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8C211.4 277.1 263.2 256 320 256zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
        },
        {
          id: 4,
          title: 'Network',
          subtitle: 'Electronic Communication Network (ECN)',
          description: '100% trade directly to Liquidity Provider guarantee, resulting in faster execution and transparent pricing.',
          viewBox: '0 0 448 512',
          pathData: 'M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z'
        }
      ]
    }
  }
}
</script>

<style scoped>
.why-choose-us {
  padding: 80px 20px;
  background: #f8f9fa;
}

.why-choose-us .section-header {
  text-align: center;
  margin-bottom: 60px;
}

.why-choose-us .section-header .main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  text-transform: none;
  letter-spacing: normal;
}

.why-choose-us .features-grid {
  max-width: 1200px;
  margin: 0 auto;
}

.why-choose-us .features-grid .grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.why-choose-us .feature-card {
  background: white;
  border: 1px solid #e1e8ed;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.why-choose-us .feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border-color: #b8860b;
}

.why-choose-us .feature-card .icon-container {
  width: 80px;
  height: 80px;
  background-color: #f5f3f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px auto;
}

.why-choose-us .feature-card .icon-container .feature-icon {
  width: 40px;
  height: 40px;
  fill: #b8860b;
}

.why-choose-us .feature-card .content-container .feature-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 10px 0;
  text-transform: none;
  letter-spacing: normal;
}

.why-choose-us .feature-card .content-container .feature-subtitle {
  font-size: 1rem;
  font-weight: 600;
  color: #7f8c8d;
  margin: 0 0 15px 0;
  line-height: 1.3;
}

.why-choose-us .feature-card .content-container .feature-description {
  font-size: 0.9rem;
  color: #5a6c7d;
  margin: 0;
  line-height: 1.6;
  font-weight: 400;
}

@media (max-width: 768px) {
  .why-choose-us .features-grid .grid-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .why-choose-us .feature-card {
    padding: 25px 15px;
  }

  .why-choose-us .section-header .main-title {
    font-size: 2rem;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .why-choose-us .features-grid .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>